import React, { useContext, useState } from 'react'
import Star from '~/components/common/Star'
import { FormattedMessage } from '~/translations/utils'
import classNames from 'classnames'
import {
  ModalBody,
  ModalFooterInForm,
  ModalHeader,
  ModalWrapper,
} from '~/components/common/Modal'
import { useForm } from 'react-hook-form'
import { post } from '~/utils/api'
import EditModal from './header/EditModal'
import Call from './header/Call'
import { TicketContext } from '~/components/tickets/Show'
import { useStore } from '~/components/tickets/store'
import useResizeObserver from 'use-resize-observer'
import Dropdown from '~/components/common/Dropdown'

type FormValues = {
  message: string
}

const Header: React.FC = () => {
  const { ticket, star, phoneNumbers } = useContext(TicketContext)
  const [closeModal, setCloseModal] = useState<boolean>(false)
  const [editModal, setEditModal] = useState<boolean>(false)
  const [type, setType] = useState('')

  const { ref, width = 0 } = useResizeObserver<HTMLElement>()

  const showModal = (e, state) => {
    e.preventDefault()
    setCloseModal(true)
    setType(state)
  }

  const close = () => {
    setCloseModal(false)
    reset()
  }

  const reopen = () => {
    post(`tickets/${ticket.id}/reopen`)
  }

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    reset,
  } = useForm<FormValues>()

  return (
    <>
      <div
        className={classNames('ticket-show-header', {
          'ticket-show-header--small': width < 550,
        })}
        ref={ref}
      >
        <div className="ticket-show-header-left">
          <Star type="ticket" star={star} id={ticket.id} />
          <span className="ticket-show-header-number">#{ticket.number}</span>
          {width >= 550 && (
            <>
              <span className="fa-light fa-pipe ticket-show-header-divide"></span>
              {ticket.title}{' '}
            </>
          )}
          <span className="tag is-link is-light ml-2">
            {ticket.state ? (
              <FormattedMessage id="ticket / state / closed" />
            ) : (
              <FormattedMessage id="ticket / state / open" />
            )}
          </span>
          {ticket.urgent && (
            <span className="tag is-link is-light ml-2">
              <FormattedMessage id="ticket / badge / urgent" />
            </span>
          )}
        </div>
        <div className="ticket-show-header-right">
          {/* {window.innerWidth >= 1100 && (
            <button
              onClick={() => setColumns(!columns)}
              className={classNames('button is-small', {
                'is-info is-light': columns,
              })}
            >
              <span className="icon is-small">
                <i className="fa-regular fa-table-columns"></i>
              </span>
            </button>
          )} */}

          {phoneNumbers.contacts && (
            <Call ticket={ticket} phoneNumbers={phoneNumbers} />
          )}
          {ticket.closed ? (
            <button className="button is-small" onClick={() => reopen()}>
              <FormattedMessage id="ticket / reopen" />
            </button>
          ) : (
            <Dropdown
              right={true}
              trigger={
                <button
                  className="button is-small"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu"
                >
                  <span>
                    <FormattedMessage id="ticket / close" />
                  </span>
                  <span className="icon is-small">
                    <i className="fas fa-angle-down" aria-hidden="true"></i>
                  </span>
                </button>
              }
            >
              <a onClick={e => showModal(e, 1)} className="dropdown-item">
                <FormattedMessage id="ticket / close / solved" />
              </a>
              <a onClick={e => showModal(e, 2)} className="dropdown-item">
                <FormattedMessage id="ticket / close / rejected" />
              </a>
            </Dropdown>
          )}
          <button
            onClick={() => setEditModal(!editModal)}
            className="button is-small"
          >
            <FormattedMessage id="ticket / edit" />
          </button>
        </div>
        {width < 550 && (
          <div className="ticket-show-header-title">{ticket.title}</div>
        )}
      </div>
      {closeModal && (
        <ModalWrapper>
          <form
            className="modal-card"
            onSubmit={handleSubmit(async data => {
              const res: any = await post(
                `tickets/${ticket.id}/close/${type}`,
                data
              )
              console.log('res', res)
              setCloseModal(false)
              reset()
            })}
          >
            <ModalHeader
              title={intl.formatMessage({
                id: 'ticket / close / modal / title',
              })}
              onClose={close}
            />
            <ModalBody>
              <div className="field">
                <textarea
                  {...register('message')}
                  className="textarea is-small autosize"
                  rows={4}
                ></textarea>
              </div>
            </ModalBody>
            <ModalFooterInForm onCancel={close} isSubmitting={isSubmitting} />
          </form>
        </ModalWrapper>
      )}
      <EditModal
        ticket={ticket}
        editModal={editModal}
        setEditModal={setEditModal}
      />
    </>
  )
}

export default Header
